// Overlays escape the scroll wrapper (fixed position, or a body portal), so clip them back to it.
export const getHorizontalClip = (bounds, left, width) => {
	const clipLeft = bounds ? Math.max(0, bounds.left - left) : 0;
	const clipRight = bounds ? Math.max(0, left + width - bounds.right) : 0;

	return clipLeft || clipRight ? `inset(0 ${clipRight}px 0 ${clipLeft}px)` : "none";
};
